const prefix = 'quickMessage/'

const type = {
    GET_LIST_USER_BY_TEXT: prefix + 'GET_LIST_USER_BY_TEXT',
    GET_LIST_USER_BY_TEXT_DONE: prefix + 'GET_LIST_USER_BY_TEXT_DONE',
    SEND_MESSAGE: prefix + 'SEND_MESSAGE',
    GET_LIST_MESSAGE: prefix + 'GET_LIST_MESSAGE',
    GET_LIST_MESSAGE_DONE: prefix + 'GET_LIST_MESSAGE_DONE',
    UPDATE_CURRENT_USER: prefix + 'UPDATE_CURRENT_USER',
    REPLY_MESSAGE: prefix + 'REPLY_MESSAGE',
    GET_LIST_REPLY_IN_MESSAGE: prefix + 'GET_LIST_REPLY_IN_MESSAGE',
    GET_LIST_REPLY_IN_MESSAGE_DONE: prefix + 'GET_LIST_REPLY_IN_MESSAGE_DONE',
    UPDATE_IS_LOAADING_MESS: prefix + 'UPDATE_IS_LOAADING_MESS',
    GET_INFO_UID_RECEIVER: prefix + 'GET_INFO_UID_RECEIVER',
    GET_INFO_UID_RECEIVER_DONE: prefix + 'GET_INFO_UID_RECEIVER_DONE',
    GET_CURRENT_LIST_ORG: prefix + 'GET_CURRENT_LIST_ORG',
    GET_CURRENT_LIST_ORG_DONE: prefix + 'GET_CURRENT_LIST_ORG_DONE',
    GET_REPLY_IN_REPLY: prefix + 'GET_REPLY_IN_REPLY',
    GET_REPLY_IN_REPLY_DONE: prefix +'GET_REPLY_IN_REPLY_DONE',
    SEND_REPLY_IN_REPLY: prefix + 'SEND_REPLY_IN_REPLY'

}

const action = {
    getReplyInReply: (reply_id) =>{
        return {
            type: type.GET_REPLY_IN_REPLY,
            payload: {reply_id}
        }
    },
    getReplyInReplyDone: (data, reply_id) =>{
        return {
            type: type.GET_REPLY_IN_REPLY_DONE,
            payload: {data, reply_id }
        }
    },
    sendReplyInReply: (body) =>{
        return {
            type: type.SEND_REPLY_IN_REPLY,
            payload: {body}
        }
    },
    getCurrentListOrg: () =>{
        return {
            type: type.GET_CURRENT_LIST_ORG,
        }
    },
    getCurrentListOrgDone: (data) =>{
        return {
            type: type.GET_CURRENT_LIST_ORG_DONE,
            payload: {data}
        }
    },
    getInfoUidReceiver: uid => {
        return {
            type: type.GET_INFO_UID_RECEIVER,
            payload: { uid },
        }
    },
    getInfoUidReceiverDone: data => {
        return {
            type: type.GET_INFO_UID_RECEIVER_DONE,
            payload: { data },
        }
    },
    updateIsloadingMess: bool => {
        return {
            type: type.UPDATE_IS_LOAADING_MESS,
            payload: { bool },
        }
    },
    getListReplyInMess: messid => {
        return {
            type: type.GET_LIST_REPLY_IN_MESSAGE,
            payload: { messid },
        }
    },
    getListReplyInMessDone: data => {
        return {
            type: type.GET_LIST_REPLY_IN_MESSAGE_DONE,
            payload: { data },
        }
    },
    replyMessage: body => {
        return {
            type: type.REPLY_MESSAGE,
            payload: {
                body,
            },
        }
    },
    updateCurrentUser: data => {
        return {
            type: type.UPDATE_CURRENT_USER,
            payload: {
                data,
            },
        }
    },

    getListmessage: (uid, status, page_number, text, isloadmore) => {
        return {
            type: type.GET_LIST_MESSAGE,
            payload: {
                uid,
                status,
                page_number,
                text,
                isloadmore,
            },
        }
    },
    getListmessageDone: (data,isloadmore) => {
        return {
            type: type.GET_LIST_MESSAGE_DONE,
            payload: {
                data,isloadmore
            },
        }
    },
    sendMessage: (receiver_uid,receiver_oid, body) => {
        return {
            type: type.SEND_MESSAGE,
            payload: {
                body,
                receiver_uid,
                receiver_oid,
            },
        }
    },
    getListuserByText: text => {
        return {
            type: type.GET_LIST_USER_BY_TEXT,
            payload: {
                text,
            },
        }
    },
    getListuserByTextDone: data => {
        return {
            type: type.GET_LIST_USER_BY_TEXT_DONE,
            payload: {
                data,
            },
        }
    },
}

export default {
    type,
    action,
}
